import { useContext } from "react";
import useOnScreen from "../../../../../hooks/useOnScreen";
import PageContext from "../../../hooks/pageContext";

/**
 * Custom hook to determine the visibility of the header and footer elements.
 * @returns {Object} - An object containing the visibility state of the header and footer.
 */
export const useStickyVisibility = ({ headerRef }) => {
    const { footerRef } = useContext(PageContext);
    const isHeaderVisible = useOnScreen(headerRef);
    const isFooterVisible = useOnScreen(footerRef);

    const isVisible =
        (headerRef?.current &&
            footerRef?.current &&
            !isHeaderVisible &&
            !isFooterVisible) ||
        false;

    return {
        isHeaderVisible,
        isFooterVisible,
        isVisible,
        headerRef,
        footerRef,
    };
};
